import React, { useEffect, useState } from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Style from "../StoreList/StoreList.module.css";
import { getSupermarketsList } from "../../Api/BarestServices";
import { errorToast } from "../../Toast/Toast";
import { cal_dis } from "../../Utils/Helper/Helper";

const SupermarketListScroll = (props) => {
  const [suppliers, setSuppliers] = useState([]);
  const [subset, setSubset] = useState([]);
  
  const userLat = localStorage.getItem("userLat");
  const userLon = localStorage.getItem("userLon");
  const faildAddress = !!userLat;

  useEffect(() => {
    getListSupermarket();
  }, []);

  useEffect(() => {
    if (suppliers && suppliers.length > 0) {
      suppliers.forEach((element) => {
        element.distance = cal_dis([element.lat, element.lon], [userLat, userLon]);
        const distanceArray = element.distance.split("-");
        const measure = distanceArray[1] === "متر" ? 1 : 1000;
        element.distanceNumber = parseFloat(distanceArray[0]) * measure;
      });
      
      suppliers.sort((a, b) => {
        if (a.working_hours.open !== b.working_hours.open) {
          return b.working_hours.open - a.working_hours.open; 
        }
        return a.distanceNumber - b.distanceNumber; 
      });
      setSubset(suppliers);
    }
  }, [suppliers]);

  const getListSupermarket = async () => {
    getSupermarketsList((succ, res) => {
      if (succ) {
        if (res?.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setSuppliers(res?.suppliers || []);
        }
      } else {
        errorToast("console.error(res) در سرور رخ داده است");
      }
    });
  };



  const filteredSuppliers = subset.filter((value) => {
    if (!props.searchInput) return true;
    if (props.searchInput === "باز") return value.working_hours.open === "1";
    if (props.searchInput === "بسته") return value.working_hours.open === 0;
    return value.name.replace(/\s+/g, "").includes(props.searchInput.replace(/\s+/g, ""))
  });

  return (
    <ul className={Style.ListHolder}>
       {filteredSuppliers.map((item, index) => (
            <Link
              key={index}
              to={{
                pathname: item.working_hours.open === "1" ? `/supplier/${item.id}/` : `/storeClosed/${item.id}`,
                state: item,
              }}
            >
              <li className={Style.StoreInfo}>
                <div className={Style.ImageHolder}>
                  <img
                    src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
                    alt="رستوران"
                  />
                </div>
                <div className={Style.StoreInfoHolder}>
                  <h4 className={Style.StoreNameHolder}>{item.name}</h4>
                  {faildAddress && (
                    <h4 className={Style.Condition}>فاصله تقریبی: {item.distance}</h4>
                  )}
                  <p className={Style.Condition}>
                    وضعیت:{" "}
                    {item.working_hours.open === "1" ? (
                      <span className={Style.openCheck}>باز</span>
                    ) : (
                      <span>بسته</span>
                    )}
                  </p>
                  <div className={Style.StoreRate}>
                    <div className={Style.FixRate}>
                      <div className={Style.RateHolder}>
                        <div className={Style.grayStar}>
                          {[...Array(5)].map((_, i) => (
                            <FontAwesomeIcon key={i} icon={faStar} />
                          ))}
                        </div>
                        <div
                          className={Style.GoldStar}
                          style={{ width: `${item.supplier_rate * 20}%` }}
                        >
                          {[...Array(5)].map((_, i) => (
                            <FontAwesomeIcon key={i} icon={faStar} />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </Link>
          ))}
    </ul>
  );
};

export default SupermarketListScroll;
